import ReactDOM from 'react-dom';
import VideoJS from 'video.js';
import MyTimeDisplay from './MyTimeDisplay';

const BaseComponent = VideoJS.getComponent('Component');

class TimeDisplay extends BaseComponent {
  constructor(player: any, options: any) {
    super(player, options);

    this.mountReactComponent = this.mountReactComponent.bind(this);

    player.ready(() => this.mountReactComponent(options));

    this.on('dispose', () => ReactDOM.unmountComponentAtNode(this.el()));
  }

  mountReactComponent(options: any) {
    ReactDOM.render(<MyTimeDisplay bridge={this} {...options} />, this.el());
  }

  createEl() {
    return VideoJS.dom.createEl('div', {
      className: 'intelligence-time-display',
    });
  }
}

export default TimeDisplay;
